import { useCallback } from 'react'

export const ConvertUtility = () => {
  const snakeToCamel = useCallback((str: string): string => {
    return str.replace(/(_\w)/g, (matches) => matches[1].toUpperCase())
  }, [])

  const convertKeysToCamel = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (obj: any): any => {
      if (Array.isArray(obj)) {
        return obj.map((item) => convertKeysToCamel(item))
      } else if (obj && typeof obj === 'object') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return Object.keys(obj).reduce((acc: any, key) => {
          const camelKey = snakeToCamel(key)
          acc[camelKey] = convertKeysToCamel(obj[key])
          return acc
        }, {})
      }
      return obj
    },
    [snakeToCamel],
  )

  const camelToSnake = useCallback((str: string): string => {
    return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)
  }, [])

  const convertKeysToSnake = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (obj: any): any => {
      if (Array.isArray(obj)) {
        return obj.map((item) => convertKeysToSnake(item))
      } else if (obj && typeof obj === 'object') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return Object.keys(obj).reduce((acc: any, key) => {
          const snakeKey = camelToSnake(key)
          acc[snakeKey] = convertKeysToSnake(obj[key])
          return acc
        }, {})
      }
      return obj
    },
    [camelToSnake],
  )

  return {
    convertKeysToCamel,
    convertKeysToSnake,
  }
}
